import QuestionAnswersPrefillTriggerGreen from './question-answers-trigger-green.json';
import QuestionAnswersPrefillTriggerRed from './question-answers-trigger-red.json';
import QuestionAnswersPrefillTriggerYellow from './question-answers-trigger-yellow.json';

export default {
  green: QuestionAnswersPrefillTriggerGreen,
  red: QuestionAnswersPrefillTriggerRed,
  yellow: QuestionAnswersPrefillTriggerYellow,
};
